
import Login from '../views/common/Login';
import Faq from '../views/common/Faq';
import Terms from '../views/common/Terms';
import Support from '../views/common/Support';
import ErrorPage from '../views/common/ErrorPage';
import VerifyUser from '../views/common/VerifyUser';
import { LoginRedirect, LogoutRedirect } from '../components/redirects';

const commonRoutes = [
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/logout',
    element: <LogoutRedirect />
  },
  {
    path: '/faq',
    element: <Faq />
  },
  {
    path: '/terms',
    element: <Terms />
  },
  {
    path: '/support',
    element: <Support />
  },
  {
    path: '/error',
    element: <ErrorPage />
  },
  {
    path: '/signup',
    element: <LoginRedirect />
  },
  {
    path: '/verify-user',
    element: <VerifyUser />
  }
];

export default commonRoutes;